<div class="col-sm-6 esquerda">
    <slider-midia *ngIf="!showLoaderMidia" [midias]="midiacapa" class="area-midias"></slider-midia>

    <div *ngIf="showLoaderMidia" class="d-grid align-items-center justify-content-center">
        <loader-page [show]="true"></loader-page>
    </div>
</div>

<div class="col-sm-6 direita">
    <div class="d-grid align-items-center">
        <div class="w-100">
            <p class="titulo">{{teste?.nome}}</p>
        </div>

        <div class="descricao" *ngIf="teste?.descricao">
            <p [innerHTML]="teste?.descricao | safeHtmlJogada"></p>
        </div>

        <btn-continuar
            *ngIf="teste"
            texto="Iniciar"
            (click)="onClickContinuar()"
            class="mt-4"
        ></btn-continuar>
    </div>
</div>
